<div class="search-header-wrapper" [ngClass]="{ 'show-title':showTitle }">
    <div class="search-header-ctnr" id="tf-sub-header-with-search" [class.search-header-ctnr-fs]="isFisherSci">
        <div class="search-header-container container-fluid">

            <div class="tf-search-header-desktop d-none d-md-block">
                <div class="search-header-text" *ngIf="showTitle">Search within TaqMan&trade; Assays and Arrays</div>
                <div [ngTemplateOutlet]="searchBar"></div>
            </div>
            <div class="tf-search-header-mobile d-md-none" *ngIf="!searchBtnClicked" (click)="openModal()">
                <div class="search-header-text">Search within TaqMan&trade; Assays and Arrays</div>
                <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M14.25 12.5764L10.8334 9.28865C12.7125 6.89221 12.3794 3.51176 10.0657 1.49787C7.75202 -0.516016 4.22331 -0.49696 1.93325 1.54179C-0.356808 3.58054 -0.650454 6.96437 1.2565 9.34037C3.16345 11.7164 6.64 12.2983 9.26876 10.6816L12.7492 14L14.25 12.5764ZM3.01484 8.86017C2.30111 8.10781 1.9 7.08638 1.9 6.02119C1.9 4.956 2.30111 3.93457 3.01484 3.18221C3.72567 2.42556 4.693 2 5.70207 2C6.71114 2 7.67846 2.42556 8.38929 3.18221C9.87024 4.75152 9.87024 7.29085 8.38929 8.86017C6.88659 10.3799 4.51754 10.3799 3.01484 8.86017Z"
                          fill="white"/>
                </svg>
            </div>
        </div>
    </div>
</div>

<div class="drawer-container d-md-none" *ngIf="searchBtnClicked">
    <div class="tf-container" [class.tf-container-fs]="isFisherSci" tf-search-header-mobile-space>
        <div class="tf-modal-header">
            <div class="search-header-text">Search within TaqMan&trade; Assays and Arrays</div>
            <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg"
                 (click)="openModal()">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M8.46762 7L14.0576 12.58L12.6376 14L7.05762 8.41L1.46762 14L0.0576172 12.58L5.63762 7L0.0576172 1.41L1.46762 0L7.05762 5.58L12.6376 0L14.0576 1.41L8.46762 7Z"
                      fill="white"/>
            </svg>
        </div>

        <div [ngTemplateOutlet]="searchBar"></div>
    </div>
</div>

<ng-template #searchBar>
    <div class="search-input-container" [ngClass]="{'search-spacing': !showTitle}">
        <div class="placeholder">
            <div class="search-container">
                <input type="text"
                       class="tf-input-text search-input-text"
                       placeholder="Enter target(s) separated by commas"
                       [(ngModel)]="searchValue"
                       (ngModelChange)="resetCounts()"
                       [ngbTypeahead]="search"
                       [focusFirst]="false"
                       (focus)="inputOnFocusEvent()"
                       (keypress)="onKeyPressHandler($event)" />
                <div class="search-target-param-row-delete" (click)="removeSelectedSpecification()">
                    <svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg" >
                        <line x1="1" y1="1" x2="9" y2="9"/>
                        <line x1="1" y1="9" x2="9" y2="1"/>
                    </svg>
                </div>
            </div>
        </div>
        <div class="dropdowns-container" [ngClass]="{'no-bottom-padding' : displaySpecies}" >
            <tf-dropdown
                [options]="applications"
                optionLabelKey="name"
                [inlineLabel]="getApplicationInlineLabel()"
                [compareFn]="compare"
                [(ngModel)]="singleSelectedVal"
                (onChange)="setSpeciesOpts()"
                [hasBlueBorder]="true"
                [scrollHeight]="520">
            </tf-dropdown>
        </div>
        <div class="dropdowns-container" *ngIf="displaySpecies">
            <tf-multi-select-dropdown
                inlineLabel = "Species (Optional)"
                [options] = "speciesList"
                optionLabelKey="name"
                [(ngModel)] = "selectedSpecies"
                [disabled] = "isSpeciesDisabled()"
                [scrollHeight]="520">
            </tf-multi-select-dropdown>
        </div>
        <div class="btn">
            <button tfFeaturedButton (click)="doSearch()"> Search</button>
        </div>
    </div>
</ng-template>

